/*@ngInject*/
const OptionGroupDropDownController = function ($rootScope, $scope, $element, $timeout, localization, configurationConstant, coreConstant) {

    $element.addClass('optionGroupDropDown');

    localization.getTranslationByKey('optionGroupDropDown').then(function (translations) {

            var timeoutList = [];
            this.isValid = true;

        this.init = function () {
            if (_.isNil(this.value) || this.value === '[select]') {
                this.value = '';
            }

            this.placeholder = _.get(translations, 'placeholder');

            this.initItemsList(this.value);

            timeoutList.push($timeout(function () {
                $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
            }.bind(this), 0));
        };

        this.initItemsList = function (selectedValue) {
            var valueMatch;

            this.itemsList = _.map(_.keys(this.values), function (key) {
                return {
                    name: key,
                    value: this.values[key]
                };
            }.bind(this));

            if (this.allowNewValues) {
                valueMatch = _.find(this.itemsList, function (item) {
                    return item.value === selectedValue;
                });
                if (_.isNil(valueMatch)) {
                    this.itemsList.push({
                        name: selectedValue,
                        value: selectedValue
                    });
                }
            }

                if(!_.isEmpty(selectedValue)) {
                    this.dropdownSelectedValue = _.find(this.itemsList, {value: selectedValue});
                    if (_.isNil(this.dropdownSelectedValue) && !_.isNil(this.value)) {
                        this.placeholder = this.value;
                        this.isValid = false;
                    }
                } else {
                    this.dropdownSelectedValue = '';
                }
                this.filteredItemsList = this.itemsList;

            this.buildTooltip();
        };

        this.buildTooltip = function () {
            this.tooltip = '';
            if (!_.isNil(this.dropdownSelectedValue) && !_.isNil(this.dropdownSelectedValue.name)) {
                if (this.dropdownSelectedValue.name.length > 45) {
                    this.tooltip = this.dropdownSelectedValue.name;
                }
            }
        };

        this.handleSelect = function () {
            if (!_.isNil(this.dropdownSelectedValue)) {
                this.initItemsList(this.dropdownSelectedValue.value);
            }

            $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
                name: this.name,
                value: !_.isNil(this.dropdownSelectedValue) ? this.dropdownSelectedValue.value : null
            });

                $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
                this.isValid = true;
            };

        this.filterItems = function (searchText) {
            var filteredItemsList = [],
                newValueMatch;

            if (!_.isEmpty(searchText)) {
                filteredItemsList = _.filter(this.itemsList, function (item) {
                    return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
                });

                if (this.allowNewValues) {
                    // Add the new value to the filtered list if the searchText entered does not match anything in
                    // the current list
                    newValueMatch = _.find(filteredItemsList, function (item) {
                        return item.name.toLowerCase() === searchText.toLowerCase();
                    });
                    if (_.isNil(newValueMatch)) {
                        filteredItemsList.push({
                            name: searchText,
                            value: searchText,
                            isCreateNew: true
                        });
                    }
                }
            } else {
                filteredItemsList = this.itemsList;
            }

            this.filteredItemsList = filteredItemsList;
        };

        this.$onChanges = function (changes) {
            if (!_.isNil(changes.values)) {
                this.init();
            }
        };

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupDropDownController', OptionGroupDropDownController);
